/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActionOwner } from '../models/ActionOwner';
import type { GuestInviteResponse } from '../models/GuestInviteResponse';
import type { GuestJobResponse } from '../models/GuestJobResponse';
import type { JobCancellationRequest } from '../models/JobCancellationRequest';
import type { JobCloneRequest } from '../models/JobCloneRequest';
import type { JobCreateRequest } from '../models/JobCreateRequest';
import type { JobFilterRequest } from '../models/JobFilterRequest';
import type { JobFilterResponse } from '../models/JobFilterResponse';
import type { JobInitialEligibilityResponse } from '../models/JobInitialEligibilityResponse';
import type { JobProgramPaymentStatus } from '../models/JobProgramPaymentStatus';
import type { JobProgramStatus } from '../models/JobProgramStatus';
import type { JobProgramSubmissionOutcome } from '../models/JobProgramSubmissionOutcome';
import type { JobResponse } from '../models/JobResponse';
import type { JobResponseWithIncentiveResult } from '../models/JobResponseWithIncentiveResult';
import type { JobResponseWithTask } from '../models/JobResponseWithTask';
import type { JobsSummary } from '../models/JobsSummary';
import type { JobsSummaryWithActionRequired } from '../models/JobsSummaryWithActionRequired';
import type { JobStage } from '../models/JobStage';
import type { JobWatchersRequest } from '../models/JobWatchersRequest';
import type { PaginatedResponse_JobContractorListWithIncentiveAndEligibilityResponse_ } from '../models/PaginatedResponse_JobContractorListWithIncentiveAndEligibilityResponse_';
import type { PaginatedResponse_JobResponse_ } from '../models/PaginatedResponse_JobResponse_';
import type { PaginatedResponse_JobSearchResponse_ } from '../models/PaginatedResponse_JobSearchResponse_';
import type { RebatesPipelineSummaryBucket } from '../models/RebatesPipelineSummaryBucket';
import type { Roles } from '../models/Roles';
import type { SortByOptions } from '../models/SortByOptions';
import type { SortDirectionOptions } from '../models/SortDirectionOptions';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class JobRoutesV1Repository {
  /**
   * Fetch All Jobs Contractor V1
   * Lists all jobs (legacy v1, replaced by `GET /api/jobs/v2`).
   *
   * Endpoint is paginated and filterable. Will show only jobs for a contractor if contractor is in context.
   * @returns PaginatedResponse_JobContractorListWithIncentiveAndEligibilityResponse_ Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1FetchAllJobsContractorV1({
    contractorId,
    programId,
    isCanceled,
    stages,
    contractorUser,
    hasContractorTaskException,
    hasOpsTaskException,
    actionOwner,
    paymentStatus,
    programStatus,
    submissionOutcome,
    pageNumber = 1,
    perPage = 25,
    sortBy = 'created_at',
    sortDirection = 'asc',
    authorization,
  }: {
    contractorId?: (Array<string> | null),
    programId?: (Array<string> | null),
    isCanceled?: (boolean | null),
    stages?: (Array<JobStage> | null),
    contractorUser?: (Array<string> | null),
    hasContractorTaskException?: (boolean | null),
    hasOpsTaskException?: (boolean | null),
    actionOwner?: (Array<ActionOwner> | null),
    paymentStatus?: (Array<JobProgramPaymentStatus> | null),
    programStatus?: (Array<JobProgramStatus> | null),
    submissionOutcome?: (Array<JobProgramSubmissionOutcome> | null),
    pageNumber?: number,
    perPage?: number,
    sortBy?: SortByOptions,
    sortDirection?: SortDirectionOptions,
    authorization?: string,
  }): CancelablePromise<PaginatedResponse_JobContractorListWithIncentiveAndEligibilityResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/v1',
      headers: {
        'authorization': authorization,
      },
      query: {
        'contractor_id': contractorId,
        'program_id': programId,
        'is_canceled': isCanceled,
        'stages': stages,
        'contractor_user': contractorUser,
        'has_contractor_task_exception': hasContractorTaskException,
        'has_ops_task_exception': hasOpsTaskException,
        'action_owner': actionOwner,
        'payment_status': paymentStatus,
        'program_status': programStatus,
        'submission_outcome': submissionOutcome,
        'page_number': pageNumber,
        'per_page': perPage,
        'sort_by': sortBy,
        'sort_direction': sortDirection,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Job
   * Adds a new job and site contact.
   * @returns JobResponseWithTask Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1CreateJob({
    requestBody,
    authorization,
  }: {
    requestBody: JobCreateRequest,
    authorization?: string,
  }): CancelablePromise<JobResponseWithTask> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/jobs/v1',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Fetch All Jobs Internal
   * Lists all jobs for internal app. No rebate estimates included.
   *
   * Endpoint is paginated and filterable.
   * @returns PaginatedResponse_JobResponse_ Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1FetchAllJobsInternal({
    contractorId,
    programId,
    isCanceled,
    isClaimedJobs,
    stages,
    opsUser,
    contractorUser,
    hasContractorTaskException,
    hasOpsTaskException,
    actionOwner,
    paymentStatus,
    programStatus,
    submissionOutcome,
    pipelineBucket,
    pageNumber = 1,
    perPage = 25,
    sortBy = 'created_at',
    sortDirection = 'asc',
    authorization,
  }: {
    contractorId?: (Array<string> | null),
    programId?: (Array<string> | null),
    isCanceled?: (boolean | null),
    isClaimedJobs?: (boolean | null),
    stages?: (Array<JobStage> | null),
    opsUser?: (Array<string> | null),
    contractorUser?: (Array<string> | null),
    hasContractorTaskException?: (boolean | null),
    hasOpsTaskException?: (boolean | null),
    actionOwner?: (Array<ActionOwner> | null),
    paymentStatus?: (Array<JobProgramPaymentStatus> | null),
    programStatus?: (Array<JobProgramStatus> | null),
    submissionOutcome?: (Array<JobProgramSubmissionOutcome> | null),
    pipelineBucket?: (RebatesPipelineSummaryBucket | null),
    pageNumber?: number,
    perPage?: number,
    sortBy?: SortByOptions,
    sortDirection?: SortDirectionOptions,
    authorization?: string,
  }): CancelablePromise<PaginatedResponse_JobResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/v1/internal',
      headers: {
        'authorization': authorization,
      },
      query: {
        'contractor_id': contractorId,
        'program_id': programId,
        'is_canceled': isCanceled,
        'is_claimed_jobs': isClaimedJobs,
        'stages': stages,
        'ops_user': opsUser,
        'contractor_user': contractorUser,
        'has_contractor_task_exception': hasContractorTaskException,
        'has_ops_task_exception': hasOpsTaskException,
        'action_owner': actionOwner,
        'payment_status': paymentStatus,
        'program_status': programStatus,
        'submission_outcome': submissionOutcome,
        'pipeline_bucket': pipelineBucket,
        'page_number': pageNumber,
        'per_page': perPage,
        'sort_by': sortBy,
        'sort_direction': sortDirection,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Fetch Jobs Summary
   * Returns the action required jobs for the contractor job list alongside with the total count per bucket.
   * @returns JobsSummaryWithActionRequired Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1FetchJobsSummary({
    contractorId,
    programId,
    isCanceled,
    isClaimedJobs,
    stages,
    opsUser,
    contractorUser,
    hasContractorTaskException,
    hasOpsTaskException,
    actionOwner,
    paymentStatus,
    programStatus,
    submissionOutcome,
    pipelineBucket,
    pageNumber = 1,
    perPage = 25,
    sortBy = 'created_at',
    sortDirection = 'asc',
    authorization,
  }: {
    contractorId?: (Array<string> | null),
    programId?: (Array<string> | null),
    isCanceled?: (boolean | null),
    isClaimedJobs?: (boolean | null),
    stages?: (Array<JobStage> | null),
    opsUser?: (Array<string> | null),
    contractorUser?: (Array<string> | null),
    hasContractorTaskException?: (boolean | null),
    hasOpsTaskException?: (boolean | null),
    actionOwner?: (Array<ActionOwner> | null),
    paymentStatus?: (Array<JobProgramPaymentStatus> | null),
    programStatus?: (Array<JobProgramStatus> | null),
    submissionOutcome?: (Array<JobProgramSubmissionOutcome> | null),
    pipelineBucket?: (RebatesPipelineSummaryBucket | null),
    pageNumber?: number,
    perPage?: number,
    sortBy?: SortByOptions,
    sortDirection?: SortDirectionOptions,
    authorization?: string,
  }): CancelablePromise<JobsSummaryWithActionRequired> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/v1/summary',
      headers: {
        'authorization': authorization,
      },
      query: {
        'contractor_id': contractorId,
        'program_id': programId,
        'is_canceled': isCanceled,
        'is_claimed_jobs': isClaimedJobs,
        'stages': stages,
        'ops_user': opsUser,
        'contractor_user': contractorUser,
        'has_contractor_task_exception': hasContractorTaskException,
        'has_ops_task_exception': hasOpsTaskException,
        'action_owner': actionOwner,
        'payment_status': paymentStatus,
        'program_status': programStatus,
        'submission_outcome': submissionOutcome,
        'pipeline_bucket': pipelineBucket,
        'page_number': pageNumber,
        'per_page': perPage,
        'sort_by': sortBy,
        'sort_direction': sortDirection,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Fetch Jobs Summary Internal
   * Returns total count per bucket for the internal jobs list.
   * @returns JobsSummary Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1FetchJobsSummaryInternal({
    contractorId,
    programId,
    isCanceled,
    isClaimedJobs,
    stages,
    opsUser,
    contractorUser,
    hasContractorTaskException,
    hasOpsTaskException,
    actionOwner,
    paymentStatus,
    programStatus,
    submissionOutcome,
    pipelineBucket,
    pageNumber = 1,
    perPage = 25,
    sortBy = 'created_at',
    sortDirection = 'asc',
    authorization,
  }: {
    contractorId?: (Array<string> | null),
    programId?: (Array<string> | null),
    isCanceled?: (boolean | null),
    isClaimedJobs?: (boolean | null),
    stages?: (Array<JobStage> | null),
    opsUser?: (Array<string> | null),
    contractorUser?: (Array<string> | null),
    hasContractorTaskException?: (boolean | null),
    hasOpsTaskException?: (boolean | null),
    actionOwner?: (Array<ActionOwner> | null),
    paymentStatus?: (Array<JobProgramPaymentStatus> | null),
    programStatus?: (Array<JobProgramStatus> | null),
    submissionOutcome?: (Array<JobProgramSubmissionOutcome> | null),
    pipelineBucket?: (RebatesPipelineSummaryBucket | null),
    pageNumber?: number,
    perPage?: number,
    sortBy?: SortByOptions,
    sortDirection?: SortDirectionOptions,
    authorization?: string,
  }): CancelablePromise<JobsSummary> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/v1/summary-internal',
      headers: {
        'authorization': authorization,
      },
      query: {
        'contractor_id': contractorId,
        'program_id': programId,
        'is_canceled': isCanceled,
        'is_claimed_jobs': isClaimedJobs,
        'stages': stages,
        'ops_user': opsUser,
        'contractor_user': contractorUser,
        'has_contractor_task_exception': hasContractorTaskException,
        'has_ops_task_exception': hasOpsTaskException,
        'action_owner': actionOwner,
        'payment_status': paymentStatus,
        'program_status': programStatus,
        'submission_outcome': submissionOutcome,
        'pipeline_bucket': pipelineBucket,
        'page_number': pageNumber,
        'per_page': perPage,
        'sort_by': sortBy,
        'sort_direction': sortDirection,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Job Filters
   * Get job filters.
   * @returns JobFilterResponse Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1GetJobFilters({
    requestBody,
    authorization,
  }: {
    requestBody: JobFilterRequest,
    authorization?: string,
  }): CancelablePromise<JobFilterResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/jobs/v1/filters',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Job Search Inputs
   * Gets a list of jobs with the response limited to omni-search relevant fields.
   * @returns PaginatedResponse_JobSearchResponse_ Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1JobSearchInputs({
    searchToken,
    ignoreCanceled = false,
    ignoreCompleted = false,
    pageNumber = 1,
    perPage = 10,
    authorization,
  }: {
    searchToken?: (string | null),
    ignoreCanceled?: boolean,
    ignoreCompleted?: boolean,
    pageNumber?: number,
    perPage?: number,
    authorization?: string,
  }): CancelablePromise<PaginatedResponse_JobSearchResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/v1/search',
      headers: {
        'authorization': authorization,
      },
      query: {
        'search_token': searchToken,
        'ignore_canceled': ignoreCanceled,
        'ignore_completed': ignoreCompleted,
        'page_number': pageNumber,
        'per_page': perPage,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Check Initial Eligibility
   * Find eligible programs based on geography, program accepting submission date, and programs associated with contractor and find any existing jobs with the same location.
   * @returns JobInitialEligibilityResponse Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1CheckInitialEligibility({
    googlePlaceId,
    unit = '',
    authorization,
  }: {
    googlePlaceId: string,
    unit?: string,
    authorization?: string,
  }): CancelablePromise<JobInitialEligibilityResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/v1/initial-eligibility/{google_place_id}',
      path: {
        'google_place_id': googlePlaceId,
      },
      headers: {
        'authorization': authorization,
      },
      query: {
        'unit': unit,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Job
   * Get a job by id.
   * @returns JobResponseWithIncentiveResult Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1GetJob({
    jobId,
    authorization,
  }: {
    jobId: string,
    authorization?: string,
  }): CancelablePromise<JobResponseWithIncentiveResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/v1/{job_id}',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Guest Job
   * Get a job by id and include invite details.
   * @returns GuestJobResponse Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1GetGuestJob({
    jobId,
    authorization,
  }: {
    jobId: string,
    authorization?: string,
  }): CancelablePromise<GuestJobResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/v1/{job_id}/guest',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Job Guest Invites
   * Get job guest invites.
   * @returns GuestInviteResponse Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1GetJobGuestInvites({
    jobId,
    authorization,
  }: {
    jobId: string,
    authorization?: string,
  }): CancelablePromise<Array<GuestInviteResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/v1/{job_id}/guest-invites',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Job Guest Invite
   * Delete a job guest invite.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1DeleteJobGuestInvite({
    jobId,
    email,
    authorization,
  }: {
    jobId: string,
    email: string,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/jobs/v1/{job_id}/guest-invites/{email}',
      path: {
        'job_id': jobId,
        'email': email,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Confirm Tasks Done Guest
   * Endpoint to send an email to contractor when guest is done with their tasks.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1ConfirmTasksDoneGuest({
    guestRole,
    jobId,
    authorization,
  }: {
    guestRole: Roles,
    jobId: string,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/jobs/v1/{guest_role}/confirm-tasks-done/{job_id}',
      path: {
        'guest_role': guestRole,
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Job By Short Code
   * Get a job by short code.
   * @returns JobResponse Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1GetJobByShortCode({
    shortCode,
    authorization,
  }: {
    shortCode: string,
    authorization?: string,
  }): CancelablePromise<JobResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/v1/code/{short_code}',
      path: {
        'short_code': shortCode,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Cancel Job
   * Cancel a job by id.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1CancelJob({
    jobId,
    requestBody,
    authorization,
  }: {
    jobId: string,
    requestBody: JobCancellationRequest,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/jobs/v1/{job_id}/cancel',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Restore Job
   * Restore a job by id.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1RestoreJob({
    jobId,
    authorization,
  }: {
    jobId: string,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/jobs/v1/{job_id}/restore',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Claim Job
   * Assign job to logged internal user.
   * @returns JobResponse Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1ClaimJob({
    id,
    authorization,
  }: {
    id: string,
    authorization?: string,
  }): CancelablePromise<JobResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/jobs/v1/{id}/claim-job',
      path: {
        'id': id,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Clone Job
   * Clones an existing job under a new program.
   * @returns JobResponseWithTask Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1CloneJob({
    requestBody,
    authorization,
  }: {
    requestBody: JobCloneRequest,
    authorization?: string,
  }): CancelablePromise<JobResponseWithTask> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/jobs/v1/{job_id}/clone',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Watch Job
   * Add job to the user's watch list.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1WatchJob({
    jobId,
    requestBody,
    authorization,
  }: {
    jobId: string,
    requestBody: JobWatchersRequest,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/jobs/v1/{job_id}/watch',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Remove Watch Job
   * Remove job from the user's watch list.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static jobRoutesV1RemoveWatchJob({
    jobId,
    userId,
    authorization,
  }: {
    jobId: string,
    userId: string,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/jobs/v1/{job_id}/watch/{user_id}',
      path: {
        'job_id': jobId,
        'user_id': userId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
